"use client";

import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Monolith() {
  const [mounted, setMounted] = useState(false);
  const [time, setTime] = useState("04:32");
  useEffect(() => {
    setMounted(true);
    const updateTime = () => {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      setTime(`${hours}:${minutes}`);
    };
    updateTime();
    const interval = setInterval(updateTime, 60000);
    return () => clearInterval(interval);
  }, []);
  const headlineWordsLine1 = ["Limited"];
  const headlineWordsLine2 = ["*Film*", "Fine", "Photography."];
  return <section data-section-id="2922" id="the-monolith" className="relative bg-background text-foreground min-h-[800px] h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/fine_art_film_photography_monochrome.png)]" />

      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' /%3E%3C/svg%3E\")"
    }} />

      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "linear-gradient(to top right, hsl(0 0% 0% / 0.85) 0%, hsl(0 0% 0% / 0.5) 40%, hsl(0 0% 0% / 0) 75%)"
    }} />

      {}
      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/fine_art_film_photography_monochrome.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/fine_art_film_photography_monochrome.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1713483/img/fine_art_film_photography_monochrome.png-wvc-sizes" alt="Limited production fine art film photography" loading="lazy" decoding="async" className="sr-only" />

      {}
      <div className="relative z-10 h-full w-full">
        <div className="mx-auto max-w-[1440px] h-full px-6 md:px-10 lg:px-16 py-8 md:py-12 grid grid-cols-12 grid-rows-[auto_1fr_auto] gap-x-6 gap-y-8">
          {}
          <div className={`col-span-12 md:col-span-6 row-start-1 transition-all duration-1000 ease-out ${mounted ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"}`}>
            <div className="font-mono text-[10px] md:text-xs tracking-[0.2em] text-foreground/70 uppercase flex flex-col gap-1">
              <span>[N&deg; 01] &mdash; John John Fine Photography</span>
              <span className="text-foreground/50">
                Limited Production Series
              </span>
            </div>
          </div>

          {}
          <div className={`col-span-12 md:col-span-6 row-start-2 md:row-start-1 md:justify-self-end transition-all duration-1000 ease-out delay-150 ${mounted ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"}`}>
            <div className="font-mono text-[10px] md:text-xs tracking-[0.15em] text-foreground/80 uppercase flex items-center gap-2 md:gap-3 flex-wrap">
              <span className="inline-flex items-center gap-1.5">
                <span className="w-1.5 h-1.5 rounded-lg bg-white" style={{
                animation: "wvc-pulse-dot 2s ease-in-out infinite"
              }} />
                Available {time}
              </span>
              <span className="text-foreground/30">&middot;</span>
              <span>Ultra High End</span>
              <span className="text-foreground/30">&middot;</span>
              <span>Museum Grade</span>
            </div>
          </div>

          {}
          <div className="col-span-12 lg:col-span-9 xl:col-span-8 row-start-3 self-end">
            {}
            <div className={`h-px bg-foreground/20 w-16 mb-8 transition-all duration-1000 ease-out delay-300 ${mounted ? "opacity-100 w-16" : "opacity-0 w-0"}`} />

            {}
            <h1 className="font-default font-light leading-[0.95] text-foreground" style={{
            fontSize: "clamp(3.5rem, 11vw, 9rem)",
            letterSpacing: "-0.03em"
          }}>
              <span className="block overflow-hidden">
                {headlineWordsLine1.map((word, i) => <span key={i} data-index={i} className={`inline-block transition-all duration-1000 ease-out ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"}`} style={{
                transitionDelay: `${400 + i * 100}ms`
              }}>
                    {word}
                  </span>)}
              </span>
              <span className="block overflow-hidden italic">
                {headlineWordsLine2.map((word, i) => <span key={i} data-index={i} className={`inline-block mr-[0.25em] transition-all duration-1000 ease-out ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"}`} style={{
                transitionDelay: `${700 + i * 100}ms`
              }}>
                    {word}
                  </span>)}
              </span>
            </h1>

            {}
            <p className={`mt-8 md:mt-10 text-base md:text-[17px] leading-relaxed text-foreground/75 max-w-[48ch] font-default transition-all duration-1000 ease-out delay-[1100ms] ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Deliberate, museum-grade film photography. Captured with intent, 
              produced in limited runs for the discerning collector.
            </p>

            {}
            <div className={`mt-10 md:mt-12 flex flex-wrap items-center gap-4 transition-all duration-1000 ease-out delay-[1300ms] ${mounted ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <Button asChild size="lg" className="h-12 px-7 bg-white text-black hover:bg-white/90 font-default text-sm tracking-wide">
                <Link to="/ShopPage">
                  Acquire Collection
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>
              <Button asChild variant="ghost" size="lg" className="h-12 px-7 border border-white/25 text-white hover:bg-white/10 hover:text-white font-default text-sm tracking-wide">
                <Link to="/InquiriesPage">Inquire / Private View</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="col-span-12 lg:col-span-3 xl:col-span-4 row-start-3 self-end justify-self-start lg:justify-self-end hidden lg:flex items-end">
            <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.2em] uppercase text-foreground/60">
              <span>Gallery Status Active</span>
              <span className="relative inline-flex">
                <span className="w-2.5 h-2.5 bg-white" style={{
                animation: "wvc-glow-pulse 4s ease-in-out infinite",
                boxShadow: "0 0 16px hsl(0 0% 100% / 0.8)"
              }} />
              </span>
            </div>
          </div>
        </div>

        {}
        <div className={`absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 transition-opacity duration-1000 delay-[1600ms] ${mounted ? "opacity-100" : "opacity-0"}`}>
          <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-foreground/60">
            Scroll
          </span>
          <div className="relative h-12 w-px overflow-hidden bg-foreground/15">
            <span className="absolute left-0 top-0 h-4 w-px bg-foreground" style={{
            animation: "wvc-scroll-line 2.2s ease-in-out infinite"
          }} />
          </div>
        </div>
      </div>

      {}
      <style>{`
        @keyframes wvc-scroll-line {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(300%); }
        }
        @keyframes wvc-glow-pulse {
          0%, 100% {
            opacity: 0.55;
            box-shadow: 0 0 8px hsl(0 0% 100% / 0.5);
          }
          50% {
            opacity: 1;
            box-shadow: 0 0 22px hsl(0 0% 100% / 0.95);
          }
        }
        @keyframes wvc-pulse-dot {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }
      `}</style>
    </section>;
}